import React from 'react';
import { GroupEventListWrapper } from '../../containers/GroupEventItem/styled';
import ViewEventListItem from '../ViewEventListItem/ViewEventListItemNew';

const GroupEventItemList = ({
    events,
    headerOptions,
    handleItemClick = () => {},
    userId,
    showFavorites,
}) => {
    return (
        <GroupEventListWrapper>
            {events.map((event) => (
                <li
                    key={event.eventId}
                    onClick={(e) => handleItemClick(event, e)}
                >
                    <ViewEventListItem
                        userId={userId}
                        header={headerOptions}
                        event={event}
                        showFavorites={showFavorites}
                    />
                </li>
            ))}
        </GroupEventListWrapper>
    );
};

export default GroupEventItemList;
